import { Outlet } from 'react-router-dom';
import clsx from 'clsx';
import Sidebar from './Sidebar';
import { useStore } from '../store/useStore';

export default function AppShell() {
  const sidebarCollapsed = useStore((state) => state.ui.sidebarCollapsed);
  const user = useStore((state) => state.auth.user);
  const logout = useStore((state) => state.logout);

  return (
    <div className="flex h-screen bg-dark-bg">
      <Sidebar />
      <div
        className={clsx(
          'flex flex-1 flex-col transition-all duration-300',
          sidebarCollapsed ? 'ml-16' : 'ml-64'
        )}
      >
        {/* Top bar */}
        <header className="flex h-14 items-center justify-between border-b border-white/10 bg-dark-bg px-6">
          <div />
          <div className="flex items-center gap-4">
            {user && (
              <span className="text-sm text-text-secondary">
                {user.name}
              </span>
            )}
            <button
              onClick={() => logout()}
              className="btn btn-ghost text-xs"
              data-testid="logout-btn"
            >
              Sign out
            </button>
          </div>
        </header>

        {/* Main content */}
        <main className="flex-1 overflow-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
